import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { SnackbarProvider, useSnackbar } from 'notistack';
import './style.scss';

function Notify({ props = {} }) {
    const { enqueueSnackbar } = useSnackbar();
    
    const handleClickVariant = () => () => {
        const error = props;
        let msg = error?.message?.responseJSON?.message ?? error.message ?? '';

        if (typeof msg !== 'string') {
            if (msg === null || msg === undefined) {
                msg = '';
            } else if (msg instanceof Error) {
                msg = msg.message || msg.toString();
            } else if (typeof msg === 'object' || Array.isArray(msg)) {
                try {
                    msg = JSON.stringify(msg);
                } catch (e) {
                    msg = String(msg);
                }
            } else {
                msg = String(msg);
            }
        }

        const variant = props.severity || 'info';
        
        enqueueSnackbar(msg, {
            variant: variant,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            autoHideDuration: 3000
        });
    };

    const handleClick = (el) => {
        if (props.isNotify && el) {
            el.click();
        }
    };

    return (
        <div className="snack-notify">
            <Button ref={handleClick} onClick={handleClickVariant()}>S</Button>
        </div>
    );
}

Notify.propTypes = {
    props: PropTypes.shape({
        severity: PropTypes.string,
        message: PropTypes.any,
        isNotify: PropTypes.bool
    }),
    severity: PropTypes.string,
    isNotify: PropTypes.bool
};

export default function IntegrationNotistack({ props = {} }) {
    return (
        <SnackbarProvider maxSnack={1}>
            <Notify props={props} />
        </SnackbarProvider>
    );
}

IntegrationNotistack.propTypes = {
    props: PropTypes.object
};